/**
 * Per-resource roles on an Event aggregate. Flat — no hierarchy; gating is
 * membership-only via plain `.includes()`. Values are prefixed with `event:`
 * so roles from different aggregates can be co-located in a single array
 * without ambiguity.
 */

import { z } from "zod";

export const EventRoleSchema = z.enum(["event:owner", "event:participant"]);

export type EventRole = z.infer<typeof EventRoleSchema>;

/** Collection schema with parse-time duplicate rejection. */
export const EventRolesSchema = z
  .array(EventRoleSchema)
  .readonly()
  .refine((roles) => new Set(roles).size === roles.length, {
    message: "EventRoles must not contain duplicates",
  });
